//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function (module) {
  'use strict';
  module
    .controller('appsController', ['$scope', 'authService', '$sce', 'apps', 'categories', '$stateParams', 'progressBar', 'ngDialog',
      'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state',
      function ($scope, authService, $sce, apps, categories, $stateParams, progressBar, ngDialog, uiGridConstants, commonDialog,
        commonDialogMessage, $state) {
        const progress = progressBar.getProgressBar();
        $scope.viewData = {};
        $scope.appDetails = {
          Id: 0,
          CategoryId: 0,
          Name: ''
        };
        $scope.isEdit = false;
        $scope.categoryId = 0;

        const id = $stateParams.id;

        categories.getCategories().then(function (arrCategories) {
          $scope.categories = arrCategories.data;
        });

        if (!!id) {
          progress.start();
          apps.getAppById(id).then(function (appDetails) {
            $scope.appDetails = appDetails.data[0];
            $scope.categoryId = $scope.appDetails.CategoryId;
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;                     
                  $scope.errTitle = 'Get App Error';
                },],
              });
            }
          })
          .finally(function () {
            progress.complete();
          });

          $scope.isEdit = true;
        };

        $scope.saveApp = function () {
          if ($scope.appForm.$valid) {
            $scope.appDetails.CategoryId = $scope.categoryId;
            addApp($scope.appDetails);
          }
        };

        function addApp(appDetails) {
          apps.addApp(appDetails).then(function () {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Add App Success';
                $scope.successMsg = 'The app has been added succesfully.';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $scope.clearAll();
              $state.go('app.apps');
            }); 
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                  $scope.errTitle = 'Save App Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });
        };

        $scope.clearAll = function () {
          $scope.isEdit = false;
          $scope.isNew = false;
          $scope.appDetails = {};
          $scope.appForm.$setPristine();
        };

        $scope.updateApp = function (id) {
          if ($scope.appForm.$valid) {
            $scope.appDetails.CategoryId = $scope.categoryId;
            const appDetails = $scope.appDetails;
            putApp(appDetails);
          };
        };

        function putApp(appDetails) {
          apps.updateApp(appDetails.Id, appDetails).then(function (appDetails) {
            const dialogPost = ngDialog.open({
              template: 'templates/partials/viewSuccessMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.strTitle = 'Update App Success';
                $scope.successMsg = 'The app has been updated succesfully';
              },],
            });
            dialogPost.closePromise.then(function (data) {
              $scope.clearAll();
              $state.go('app.apps');
            });
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'dlg-template-app',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.appError = err.statusText + ' ' + err.data;
                  $scope.messageTitle = 'Update App Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });
        }

        //ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: true,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          columnDefs: [{
            name: 'Name',
            visible: true,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            }
          }, {
            name: 'CategoryName',
            displayName: 'Category Name',
            visible: true,
            enableSorting: true,
            enableColumnResizing: true,
          },],
          rowTemplate: '<div ng-dblclick="grid.appScope.onDblClick(row)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell ></div>',
          onRegisterApi: function (gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
            });
            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              setGridData();
            });
            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
              } else {
                $scope.rowSelecting = false;
              }
            });
          },
        };

        $scope.onDblClick = function (row) {
          $scope.rowSelectingId = row.entity.Id;
          $scope.view(row.entity);
          // Override default rowSelection action
          row.isSelected = true;
          $scope.rowSelecting = true;
        };

        function setGridData() {
          progress.start();
          apps.getApps().then(function (arrApps) {
            const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            $scope.gridOptions.data = arrApps.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
            $scope.gridOptions.totalItems = arrApps.data.length;
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                  $scope.errTitle = 'App Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });

        };
        setGridData();
        $scope.view = function (rowEntity) {
          const selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
          if (!!selectedRow) {
            $scope.viewData.name = selectedRow.Name;
            $scope.viewData.id = selectedRow.Id;
            $scope.viewData.category = selectedRow.CategoryName;

            const view = ngDialog.open({
              template: 'templates/partials/viewApp.html',
              className: 'ngdialog-theme-plain',
              scope: $scope,
            });
            view.closePromise.then(function (data) {
              $scope.viewData = {};
            });
          }
        };
        $scope.deleteApp = function () {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete App?';
              $scope.strMsg = 'Do you really want to delete this app?';
            },],
          });
          confirm.closePromise.then(function (data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              apps.deleteApp($scope.rowSelectingId).then(function (response) {
                const dialog = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Delete App Success';
                    $scope.successMsg = 'The app has been succesfully deleted.';
                  },],
                });
                dialog.closePromise.then(function (data) { });
              }, function (err) {
                if (err.status != 401) {
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;                     
                      $scope.errTitle = 'Delete App Error';
                    },],
                  });
                  dialog.closePromise.then(function (data) { });
                }
              })
                .finally(function () {
                  progress.complete();
                  setGridData();
                });
            }
          });
        };
        $scope.edit = function () {
          $state.go('app.editApp', {
            id: $scope.rowSelectingId,
          });
        };

      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/appsController.js